export const isCreatedInLast24h = (createdAt) => {
  const fullDayMs = 24 * 60 * 60 * 1000
  const timeSinceCreatedMS = Date.now() - createdAt

  return fullDayMs - timeSinceCreatedMS >= 0
}
